import React, { useState } from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { TextField, Button, TextareaAutosize } from "@mui/material";
import {
  FaLinkedin,
  FaWhatsapp,
  FaTwitter as Twitter,
  FaFacebook,
} from "react-icons/fa";
import { toast } from "react-hot-toast";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [feedback, setFeedback] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phoneRegex = /^[6-9]\d{9}$/;

    if (!phoneRegex.test(formData.phone)) {
      toast.error("Pls Enter Valid Mobile No");
      return;
    }

    try {
      const response = await fetch(
        "https://rohan-tax-services.onrender.com/api/auth/submitreq",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      const msg = data.msg;

      if (response.ok) {
        toast.success(msg);
        setFormData({
          name: "",
          company: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        toast.error(msg);
      }
    } catch (error) {
      console.error("Error:", error);
      setFeedback("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className="min-h-full bg-white flex items-center justify-center sm:p-4 p-2">
      <div className="w-full max-w-6xl mx-auto text-center text-black py-12">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold">
            Get In
            <span className="text-[#151C62] border-b-2 border-[#151C62] pb-1">
              {" "}
              Contact
            </span>
          </h2>
        </div>
        <p className="text-lg mb-12">
          Rohan's Tax Services is ready to provide the right solution according
          to your needs.
        </p>

        <div className="bg-gray-50 rounded-2xl p-10 grid md:grid-cols-2 gap-8">
          {/* Left Column */}
          <div className="text-left">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Get in touch
            </h2>
            <p className="text-gray-600 mb-8">
              Professional tax services and financial consulting for individuals
              and businesses.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="bg-[#151C62] p-3 rounded-full">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Office</h3>
                  <p className="text-gray-600">
                    Office: F-217, 2nd Floor, Sumel-7, X Roads, nr. Soni’s
                    Chawl,{" "}
                  </p>
                  <p className="text-gray-600">
                    Rakhial, Ahmedabad, Gujarat 380023
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-[#151C62] p-3 rounded-full">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Email Us</h3>
                  <a
                    href="mailto:nilesh.h.gajjar@gmail.com"
                    className="text-gray-600"
                  >
                    nilesh.h.gajjar@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-[#151C62] p-3 rounded-full">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Call Us</h3>
                  <a href="tel:+919825114973" className="text-gray-600">
                    Mobile no: +91-9825114973
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <h3 className="font-semibold text-gray-900 mb-4">
                Follow our social media
              </h3>
              <div className="flex gap-4">
                {[
                  {
                    name: "linkedin",
                    icon: <FaLinkedin className="w-5 h-5 text-white" />,
                    link: "https://www.linkedin.com/in/nilesh-h-gajjar-14b3ba16/",
                  },
                  {
                    name: "facebook",
                    icon: <FaFacebook className="w-5 h-5 text-white" />,
                    link: "https://www.facebook.com/share/12CvHRQtGB2/?mibextid=wwXIfr",
                  },
                  {
                    name: "whatsapp",
                    icon: <FaWhatsapp className="w-5 h-5 text-white" />,
                    link: "https://wa.me/919825114973",
                  }, // Replace with your WhatsApp number link
                  {
                    name: "twitter",
                    icon: <Twitter className="w-5 h-5 text-white" />,
                    link: "https://x.com/nileshgajjar?s=11&t=3l0xYRzp4MyJMVA-KsjDag",
                  },
                  {
                    name: "mail",
                    icon: <Mail className="w-5 h-5 text-white" />,
                    link: "mailto:nilesh.h.gajjar@gmail.com",
                  },
                ].map((social) => (
                  <a
                    key={social.name}
                    href={social.link}
                    className="bg-[#151C62] p-2 rounded-full hover:bg-[#151C62] transition-colors"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          {/* Right Column */}
          <div className="text-left">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Send us a message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6 p-2">
              <div className="grid md:grid-cols-2 gap-4">
                <TextField
                  label="Name"
                  variant="outlined"
                  required
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full"
                />
                <TextField
                  label="Company"
                  variant="outlined"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <TextField
                  label="Phone"
                  variant="outlined"
                  required
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full"
                />
                <TextField
                  label="Email"
                  variant="outlined"
                  required
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full"
                />
              </div>

              <TextField
                label="Subject"
                variant="outlined"
                required
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="w-full"
              />

              <div>
                <label className="text-sm font-medium text-gray-900 mb-2 block">
                  Message
                </label>
                <TextareaAutosize
                  placeholder="Write your message here"
                  minRows={5}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-md p-2"
                />
              </div>

              <Button
                type="submit"
                variant="contained"
                className="float-right"
                sx={{
                  bgcolor: "#151C62",
                  color: "white",
                }}
              >
                Send
              </Button>
            </form>

            {feedback && (
              <p className="mt-4 text-sm text-gray-800">{feedback}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
